<!--
 - Author : wanghongling.
 - Date   : 2019/5/28.
 - File   : zBRestaurant.周边餐饮
 -->

<template>
  <div class="zb-restaurant">
    <layer title="周边餐饮" padding="10px 20px 5px" width="418px">
      <ul :class="['zb-list', zBList.length<4?'item-flex':'']" v-if="zBList && zBList.length>0">
        <li
            class="zb-list-item"
            v-for="(item, index) in zBList"
            :key="index"
            @click="showZBList(item,index)">
          <div class="zb-list-item-left">
            <i :class="['iconfont', item.icon]"></i>
          </div>
          <div class="zb-list-item-right">
            <p>{{item.typeName}}</p>
            <p><i>{{item.num}}</i><span>家</span></p>
          </div>
        </li>
      </ul>
      <div class="no-the-data h140" v-if="zBList && zBList.length===0">
        <div>
          <i class="iconfont icon-kuaican dzi"></i>
          <p>暂无周边餐饮</p>
        </div>
      </div>
    </layer>
    <!--餐饮列表弹窗-->
    <transition name="slide-right-fade">
      <div class="zBPop" v-if="resShow">
        <popup :title="'周边餐饮 - ' + thTitle" width="382px" @closeEvent="closeList">
          <ul class="typeList">
            <li class="typeList-item" v-for="(list, i) in typeList" :key="i" @click="showDetail(list, i)">
              <div class="typeList-item-left">
                <div class="img">
                  <img :src="imgUrl+list.fileIds[0]" alt="">
                </div>
              </div>
              <div class="typeList-item-right">
                <p class="title">{{list.peripheralName}}</p>
                <p class="address"><i class="iconfont icon-dingwei"></i>{{list.address}}</p>
              </div>
            </li>
          </ul>
        </popup>
      </div>
    </transition>
    <!--餐饮详情弹窗-->
    <transition name="slide-right-fade">
      <div class="zbDetailPop" v-if="detailShow">
        <popup :title="detailTitle" class="de-title" width="503px" @closeEvent="detailShow = false">
          <div class="detail-cont">
            <div class="detail-cont-img" v-for="(files, num) in resDetail.fileIds" :key="num">
              <img :src="imgUrl+files" alt="">
            </div>
            <div class="detail-cont-address">
              <i class="iconfont icon-dingwei"></i>{{resDetail.address}}
            </div>
          </div>
          <div class="detail-his">
            <div class="detail-his-name">
              <div class="detail-his-name-left">巡查记录</div>
              <div class="detail-his-name-right">
              </div>
            </div>
            <div class="his-list">
              <div class="his-list-item" v-for="(item, index) in lookList" :key="index">
                <p class="item-time">{{item.createTime}}</p>
                <p class="item-cont">{{item.content}}</p>
                <ul class="his-img">
                  <li class="his-img-item" v-for="(img, i) in item.fileIds" :key="i">
                    <div class="img" @click="showPic(imgUrl+img)">
                      <img :src="imgUrl+img" alt="">
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <el-pagination
                background
                small
                v-if="total>2"
                :current-page="page"
                :page-size="pageSize"
                @current-change="pageChange"
                layout="prev, pager, next"
                :total="total">
            </el-pagination>
            <div class="no-the-data h140" v-if="lookList && lookList.length===0">
              <div>
                <i class="iconfont icon-zanwushuju dzi"></i>
                <p>暂无巡查记录</p>
              </div>
            </div>
          </div>
        </popup>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'zBRestaurant',
  data () {
    return {
      orgId: this.$store.getters.userInfo.orgId,
      imgUrl: this.$store.getters.fileApi,
      resShow: false,
      detailShow: false,
      zBList: [],
      typeList: [],
      thTitle: '',
      detailTitle: '',
      tmpIndex: null,
      detailIndex: null,
      page: 1,
      pageSize: 2,
      total: 10,
      lookList: [],
      resDetail: {},
      peripheralId: ''
    }
  },
  props: {
    selectOrgId: {}
  },
  watch: {
    selectOrgId: {
      handler(cur) {
        this.orgId = cur
        this.getFoodShopTypeCount()
      },
      deep: true
    }
  },
  mounted() {
    this.orgId = this.$store.getters.userInfo.orgId
    this.getFoodShopTypeCount()
  },
  methods: {
    /**
     * 关闭列表页
     * @author: whl
     * @createDate: 2019/9/10
     * @return {Object}
     */
    closeList() {
      this.resShow = false
      this.detailShow = false
    },
    /**
     * 显示查看图片框
     * @author: whl
     * @createDate: 2019/9/10
     * @param item 图片信息
     * @return {Object}
     */
    showPic (item) {
      this.$superMessage('查看图片', '', {imgPic: item, btnShow: false}).then(() => {
        // do sth
      }).catch(() => {
        // do sth
      })
    },
    /**
     * 切换页面
     * @author: whl
     * @createDate: 2019/9/10
     * @param e
     * @return {Object}
     */
    pageChange(e) {
      this.page = e
      this.getGatrolRecordList(this.peripheralId)
    },
    /**
     * 显示周边餐饮列表
     * @author: whl
     * @createDate: 2019/6/4
     * @param e
     * @param index
     * @return {Object}
     */
    showZBList (e, index) {
      if (this.tmpIndex === index) {
        this.resShow = !this.resShow
      } else {
        this.resShow = true
      }
      this.thTitle = e.typeName
      this.tmpIndex = index
      this.getPeripheralFoodShopType(e.type)
      this.detailShow = false
    },
    /**
     * 显示周边餐饮详情
     * @author: whl
     * @param index
     * @param item
     * @createDate: 2019/9/6
     * @return {Object}
     */
    showDetail(item, index) {
      if (this.detailIndex === index) {
        this.detailShow = !this.detailShow
      } else {
        this.detailShow = true
      }
      this.page = 1
      this.detailTitle = item.peripheralName
      this.detailIndex = index
      this.peripheralId = item.peripheralId
      this.getPeripheralFoodShop(item.peripheralId)
      this.getGatrolRecordList(item.peripheralId)
    },
    /**
     * 获取餐饮巡查记录
     * @author wanghongling
     * @param peripheralId 主键id
     * @createDate 2019/9/9
     */
    getGatrolRecordList(peripheralId) {
      let params = {
        orgId: this.orgId,
        page: this.page,
        pageSize: this.pageSize,
        peripheralId: peripheralId
      }
      console.log('params', params)
      this.$request.patrolRecordListGet(params).then(res => {
        console.log('获取餐饮巡查记录', res)
        if (!this.$utils.isEmptyObject(res)) {
          this.lookList = res.resultList
          this.total = res.totalCount
        }
      }).catch(e => {
        console.error(e)
      })
    },
    /**
     * 统计各类别的商家数量
     * @author: whl
     * @createDate: 2019/6/4
     * @return {Object}
     */
    getFoodShopTypeCount () {
      this.$request.peripheralFoodShopTypeCountGet({orgId: this.orgId}).then(res => {
        console.log('统计各类别的商家数量', res)
        if (!this.$utils.isEmptyObject(res)) {
          res.map((v, i) => {
            switch (v.type) {
              case '01':
                this.$set(res[i], 'icon', 'icon-kuaican')
                break
              case '02':
                this.$set(res[i], 'icon', 'icon-tiandianyinpin')
                break
              case '03':
                this.$set(res[i], 'icon', 'icon-icon-test')
                break
              case '04':
                this.$set(res[i], 'icon', 'icon--fenlei-jiancanbiandang')
                break
              case '05':
                this.$set(res[i], 'icon', 'icon-liaoli')
                break
              case '06':
                this.$set(res[i], 'icon', 'icon-xiaochimianshi')
                break
              default:
                this.$set(res[i], 'icon', 'icon-kuaican')
                break
            }
          })
          this.zBList = res
        }
      }).catch(e => {
        console.error('**99*9*9*9', e)
      })
    },
    /**
     * 根据商家类别获取周边商家信息
     * @author: whl
     * @createDate: 2019/6/4
     * @param e
     * @return {Object}
     */
    getPeripheralFoodShopType (e) {
      let params = {
        orgId: this.orgId,
        type: e
      }
      this.$request.peripheralFoodShopTypeGet(params).then(res => {
        console.log('根据商家类别获取周边商家信息', res)
        if (!this.$utils.isEmptyObject(res)) {
          this.typeList = res
        }
      }).catch(e => {
        console.error(e)
      })
    },
    /**
     * 根据主键获取周边商家信息
     * @author: whl
     * @createDate: 2019/9/9
     * @param peripheralId 主键id
     * @return {Object}
     */
    getPeripheralFoodShop (peripheralId) {
      let params = {
        peripheralId: peripheralId
      }
      this.$request.peripheralFoodShopGet(params).then(res => {
        console.log('根据主键获取周边商家信息', res)
        if (!this.$utils.isEmptyObject(res)) {
          this.resDetail = res
        }
      }).catch(e => {
        console.error(e)
      })
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less">
  @import '../../assets/less/color';
  .zb-restaurant{
    position: relative;
    padding-bottom: 15px;
    .item-flex{
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .zb-list{
      display: flex;
      flex-wrap: wrap;
      margin-bottom: -15px;
      min-height: 120px;
      &-item{
        width: 33%;
        display: flex;
        align-items: flex-start;
        padding: 10px 8px;
        border-radius: 4px;
        &-left{
          width: 40px;
          text-align: center;
          i{
            color: @hardYellow;
            font-size: 25px;
            margin-top: -5px;
            display: inline-block;
          }
          .icon-tiandianyinpin{
             font-size: 28px;
           }
        }
        &-right{
          color: @lightBlue;
          font-size: 15px;
          i{
            font-size: 20px;
            font-weight: bold;
            font-style: normal;
            color: #fff;
          }
          span{
            color: @lightGrey;
            padding-left: 5px;
          }
        }
      }
      &-item:hover{
        background-color: rgba(0,0,0,.3);
        cursor: pointer;
      }
    }
    /*餐饮列表弹窗*/
    .zBPop{
      position: absolute;
      right: 430px;
      top: 0;
      z-index: 2;
      .typeList{
        max-height: 525px;
        overflow: auto;
        margin-top: 5px;
        padding-right: 10px;
        /*margin-right: -8px;*/
        &-item{
          display: flex;
          margin-bottom: 15px;
          cursor: pointer;
          &-left{
            justify-content: center;
            align-items: center;
            display: flex;
            .img{
              width: 130px;
              height: 90px;
              overflow: hidden;
              display: flex;
              justify-content: center;
              align-items: center;
              border: 3px solid #05546b;
              background-color: #fff;
              img{
                width: 100%;
              }
            }
          }
          &-right{
            margin-left: 10px;
            flex: 1;
            p.title{
              font-size: 18px;
              color: #fff;
              padding-bottom: 10px;
              padding-top: 5px;
              overflow: hidden;
              width: 98%;
              text-overflow: ellipsis;
              -o-text-overflow: ellipsis;
              white-space:nowrap;
            }
            p.address{
              color: #0aaade;
              font-size: 14px;
              -webkit-box-align: start;
              display: -webkit-box;
              overflow: hidden;
              text-overflow: ellipsis;
              word-break: break-all;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              i{
                font-size: 20px;
                margin-right: 1px;
                vertical-align: sub;
              }
            }
          }
        }
        &-item:last-child{
          margin-bottom: 0;
        }
      }
    }
    /*餐饮详情弹窗*/
    .zbDetailPop{
      position: absolute;
      right: 835px;
      top: 0;
      z-index: 2;
      .de-title{
        .popup-wraps-content{
          overflow-y: inherit;
        }
        .popup-wraps-title{
          text-align: center;
          color: #fff;
        }
      }
      .detail-cont{
        &-img{
          width: 100%;
          max-height: 237px;
          display: flex;
          align-items: center;
          text-align: center;
          overflow: hidden;
          margin-top: 5px;
          img{
            width: 100%;
          }
        }
        &-address{
          color: #0aaade;
          font-size: 14px;
          display: flex;
          word-break: break-all;
          margin: 10px 0 15px;
          align-items: baseline;
          i{
            font-size: 20px;
            margin-right: 1px;
            vertical-align: sub;
          }
        }
      }
      .detail-his{
        &-name{
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-bottom: 5px;
          &-left{
            font-size: 18px;
            color: #fff;
            padding-left: 4px;
          }
          &-right{
            border-bottom: 1px solid #156893;
            flex: 1;
            margin-left: 15px;
          }
        }
        .his-list{
          padding-top: 5px;
          &-item {
            background-color: #011524;
            padding: 12px 15px 10px;
            margin-bottom: 12px;
            p{
              padding-bottom: 5px;
            }
            .item-time{
              color: #0aaade;
              font-size: 14px;
            }
            .item-cont{
              color: #00fffc;
              font-size: 14px;
              word-break: break-all;
            }
            .his-img{
              display: flex;
              flex-wrap: wrap;
              /*justify-content: space-between;*/
              &-item{
                padding: 0 6px;
              }
              .img{
                width: 130px;
                height: 90px;
                display: flex;
                align-items: center;
                justify-content: center;
                overflow: hidden;
                border: 3px solid #05546b;
                background-color: #fff;
                margin-top: 7px;
                cursor: pointer;
                img{
                  width: 100%;
                }
              }
            }
          }
          &-item:last-child{
            margin-bottom: 5px;
          }
        }

        /*分页样式*/
        .el-pagination{
          text-align: center;
          margin-bottom: -15px;
        }
        .el-pagination.is-background .el-pager li {
          background-color: inherit;
          color: #0aaade;
          margin: 0 5px;
          font-size: 18px;
          font-weight: normal;
        }
        .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev{
          background: inherit;
          color: #0aaade;
          margin: 0;
        }
        .el-pagination.is-background .el-pager li:not(.disabled).active {
          background-color: #004270 !important;
          color: #fff;
        }
        .el-pagination .btn-next .el-icon, .el-pagination .btn-prev .el-icon {
          display: block;
          font-size: 18px;
          font-weight: 700;
        }
        .el-pagination.is-background .el-pager li {
          background: #02253f;
          color: #0aaade;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index/zBRestaurant.vue